var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCompass = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 32,
  height: 32,
  viewBox: "0 0 31 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  opacity: 0.824
}, /*#__PURE__*/React.createElement("path", {
  d: "M19.05 16.093 15.458 4.766l-3.59 11.327h-.015l.007.024-.007.022h.015l3.59 11.327 3.592-11.327h.014l-.008-.022.008-.024zm-3.591 7.844L13.31 17.16h4.298z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M15.459.774C6.999.774.116 7.657.116 16.117S7 31.459 15.46 31.459s15.344-6.883 15.344-15.342C30.804 7.657 23.92.774 15.46.774zm0 29.092c-7.582 0-13.75-6.168-13.75-13.75s6.168-13.75 13.75-13.75S29.21 8.536 29.21 16.117c0 7.582-6.169 13.75-13.751 13.75z"
}))));
export default SvgCompass;